import { fadeIn, nToPx, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const tooltipPositionerClass = style([
  fadeIn,
  {
    zIndex: themeVars.zIndex.tooltip,
  },
]);

export const tooltipContentClass = style({
  fontSize: themeVars.font.size.textMd,
  backgroundColor: themeVars.colors.neutrals.black100,
  color: themeVars.colors.neutrals.white,
  borderRadius: `${themeVars.radius.md} !important`,
  boxShadow: themeVars.shadow.elevationSmall,
  padding: nToPx(themeVars.space.x2, themeVars.space.x4),
  maxWidth: 500,
});

export const tooltipTitleClass = style({
  fontWeight: themeVars.font.weight.bold,
});

export const tooltipDescriptionClass = style({
  marginTop: themeVars.space.x2,
  fontWeight: `${themeVars.font.weight.regular} !important`,
});

export const tooltipTriggerResetClass = style({
  background: 'unset',
  border: 'inherit',
});
